<template>
  <div>    
    <div class="row">
      <div class="col-lg-12 col-md-12 box-release">        
          <HeatMap></HeatMap>
      </div>
      <div class="col-lg-6 col-md-6 box-release">        
          <HeatMapSensor></HeatMapSensor>
      </div>
      <div class="col-lg-6 col-md-6 box-release">        
          <HeatMapSensorAppointments></HeatMapSensorAppointments>
      </div>
    </div>
  </div>
</template>
<script>
  import {Chart} from 'highcharts-vue'
  import HeatMap from 'src/components/Dashboard/Views/ChartsOnline/HeatMap'
  import HeatMapSensor from 'src/components/Dashboard/Views/ChartsOnline/HeatMapSensor'
  import HeatMapSensorAppointments from 'src/components/Dashboard/Views/ChartsOnline/HeatMapSensorAppointments'

  import { mapMutations } from 'vuex';

  export default {
    name: 'app',
    options: null,
    components: {
      highcharts: Chart,
      HeatMap: HeatMap,
      HeatMapSensor: HeatMapSensor,
      HeatMapSensorAppointments: HeatMapSensorAppointments,
    },
    data () {
    return {
    }
  },
  mounted: function () {
    this.changeTab('online');
  },
  methods: {
    ...mapMutations(['changeTab'])
  }
}
</script>
<style>
  .height-box{
    height: 430px;
    
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Online2.vue